module.exports = __webpack_public_path__ + "img/icon_checkdone_momo.a0a76cb4.svg";